import { Col, Container, Row } from 'react-bootstrap';
import DefaultCard from '../../components/DefaultCard';
import GenericCard from '../../components/GenericCards/GenericCards';
import CustomSelect from '../../components/Select';


import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';

const today = new Date();

const currentYear = new Date().getFullYear();

const startDate = new Date(currentYear, 0, 1);

const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

const formattedStartDate = formatDate(
  startDate,
  DateFormats.SHORT_MONTH_DAY_YEAR
);
const formattedStartDateUS = formatDate(startDate, DateFormats.US);
const formattedEndDate = formatDate(endDate, DateFormats.SHORT_MONTH_DAY_YEAR);
const formattedEndDateUS = formatDate(endDate, DateFormats.US);

const SDR = () => {
  return (
<Container className={'cnd-custom-container mt-11 mb-3'}>
     
      
      <Row className={'mt-13'}>
      
        <Col>
          <GenericCard className={'px-10 py-lg-10'} variant={'white'}>
            <Row className={'align-items-center px-5 py-10'}>
              <Col
                className={'d-flex flex-column col-12 col-lg-3 ms-10 ms-lg-0'}
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Starting Balance - {formattedStartDateUS}
                </span>
                <span className={'text-sm-24-lg-32'}>$47,001.77</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-3 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Pay Credits & Adjustments
                </span>
                <span className={'text-sm-24-lg-32'}>$5,741.78</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-2 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Interest Credits
                </span>
                <span className={'text-sm-24-lg-32'}>$1,849.07</span>
              </Col>
              <Col className={'col-12 col-lg-3 ms-auto mt-11 mt-lg-0'}>
                <DefaultCard
                  className={'py-7 px-10'}
                  leftSubheading={
                    <Row>
                      <Col className={'col-12 text-lg-end mb-3 ps-0'}>
                        <span className={'text-white'}>
                          Ending Balance - {formattedEndDateUS}
                        </span>
                      </Col>
                      <Col className={'col-12 text-lg-end ps-0'}>
                        <span className={'text-sm-24-lg-32'}>$54,592.62</span>
                      </Col>
                    </Row>
                  }
                  variant={'blue'}
                />
              </Col>
            </Row>
            
          </GenericCard>
        </Col>

        
      </Row>
         
    </Container>
   );
};
    export default SDR;